import { render, staticRenderFns } from "./PublicationsIndex.vue?vue&type=template&id=10fde6a8&"
import script from "./PublicationsIndex.vue?vue&type=script&lang=js&"
export * from "./PublicationsIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports